import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import Vuelidate from 'vuelidate';
import Clipboard from 'v-clipboard';
import VueContentPlaceholders from 'vue-content-placeholders'
import VueClipboard from 'vue-clipboard2'
import VueChatScroll from 'vue-chat-scroll'
import VueMce from 'vue-mce';
import VueCountdown from '@chenfengyuan/vue-countdown';
import 'chartist/dist/chartist.min.css'

Vue.use(require('vue-chartist'))
Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#0D47A1',
    secondary: '#1E88E5',
    success: '#388E3C',
    info: '#ffaa2c',
    error: '#B71C1C',
    warning:'#FBC02D'
  }
})
Vue.component(VueCountdown.name, VueCountdown);
Vue.use(Clipboard);
Vue.use(Vuelidate);
Vue.use(VueContentPlaceholders)
Vue.use(VueClipboard)
Vue.use(VueChatScroll)
Vue.use(VueMce);


Vue.filter('truncate', function (text, length, suffix) {
  return text.substring(0, length) + suffix;
});

Vue.filter('formatDate', function (value) {
  if (value) {
    let d = new Date(value).toLocaleString('en-GB')
    return `${d}`
  }
});